import { z } from 'zod'

/**
 * What goes in a link or a feedback row to say which job it is about: the
 * reference and nothing else. The shape rules out an address, a phone number
 * or markup, so a person's details never travel in a URL.
 */
export const jobReferenceSchema = z
  .string()
  .trim()
  .min(1)
  .max(60)
  .regex(/^[A-Za-z0-9][A-Za-z0-9 ._-]*$/)
